;(function () {
  'use strict'

  angular
    .module('contrast.date')
    .constant('DEFAULT_DATETIME_FORMAT', 'MM/dd/yyyy hh:mm a')
    .constant('DEFAULT_DATE_FORMAT', 'MM/dd/yyyy')
    .constant('DEFAULT_TIME_FORMAT', 'hh:mm a')
})()
